<template>
  <div>
    <b-row>
      <b-col>
        <b-button variant="primary" v-on:click="excelIndir()" size="sm" style="height: 40px">
          <download-excel v-if="!isMobile()" class="btn btn-default" :data="excelYazdirilacakData" name="excelData.xls"
            style="
                width: 75px;
                height: 25px;
                text-align: center;
                padding: 0px;
                color: white;
                border-style: solid;
                border-color: #0d6efd;
                border-radius: 3px;
                background-color: #0d6efd;
              ">
            Excel
          </download-excel>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { isMobile } from "mobile-device-detect";
export default {
  props: ["excelData"],

  data() {
    return {
      isMobile: function () {
        return isMobile;
      },
      excelYadirData: [],
      excelYazdirilacakData: [],
    };
  },
  methods: {
    excelIndir() {
      this.excelYadirData = [];
      for (let index = 0; index < this.excelData.length; index++) {
        var pazaryer = [];
        var pazayerParse = JSON.parse(this.excelData[index].Pazaryeri);
        for (let j = 0; j < pazayerParse.length; j++) {
          pazaryer.push(pazayerParse[j].program);
        }
        this.excelYadirData.push({
          Stok_Kodu: this.excelData[index].stokKodu,
          Barkod: this.excelData[index].Barkod,
          Stok_Adi: this.excelData[index].StokAdi,
          Son_Alis: this.excelData[index].SonAlis,
          Liste_Fiyat: this.excelData[index].LISTE_FIAT,
          Stok_Adet: this.excelData[index].stokAdet,
          Pazaryerleri: pazaryer,
        });
      }
      this.excelYazdirilacakData = this.excelYadirData;
    },
  },
  created() {
    // alert("in");
    //   this.excelYadirData = this.excelData;
  },
};
</script>